export const googleConfig = {
    // clientSecret: "VcGiXPH3asVSqYEd8Ll8wg6p",
    clientId: "817437099485-oj6pd4lp6d8q3ghe9ijo68qr4nib3mlb.apps.googleusercontent.com",
    apiKey: "AIzaSyB-OjeCffJh_ApvbEH3UUXoNxgFRqxNrRo",
    discoveryDocs: [
        "https://sheets.googleapis.com/$discovery/rest?version=v4"
    ],
    scope: 'https://www.googleapis.com/auth/spreadsheets',
    ux_mode: 'redirect',
};

export default googleConfig;